module.exports = __webpack_public_path__ + "img/fresher.05d4ea50.svg";